import api from '../../api'
// import entites from '../../api/models/entites';
const state = {
    all:[],
    typesentite:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: '',
            action: '',
            user_name: '',
            user_email: '',
            entite_nom: '',
            description: '',
            echeance: '',
            gps_lat_long: '',
            ip: '',
            method: '',
            role_name: '',
            navigateur: '',
            created_at: '',
            deleted_at: '',
            updated_at: '',
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                action: element.action,
                user_name: element.user_name,
                user_email: element.user_email,
                entite_nom: element.entite_nom, 
                description: element.description,
                echeance: element.echeance,
                gps_lat_long: element.gps_lat_long,
                ip: element.ip,
                method: element.method,
                role_name: element.role_name,
                navigateur: element.navigateur,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    },
    types(state){
        let data = []
        let type = {
            libelle: ''
        }
        state.typesentite.forEach(element => {           
            type = {
                libelle: element             
            }
            data.push(type)
        });
        return data;
    },
}
const mutations= {
    logActivities(state, log) {
        //console.log(log)
        state.all = log
    },
    settypesentity(state, typesentities) {
        state.typesentite = typesentities
    },
    addEntity(state,entity){
        state.all.push(entity)
    }
}

const actions={
    get_logactivity({ commit }, serverParams){
        return api.mouchards.get_logactivity(serverParams).then((response)=>{
            //console.log('Log activities :',response.data.data)
            commit('logActivities', response.data.data)
            return response.data
        })
    },
    get_all_authentites({ commit }, serverParams){
        let tab_temp=[]
        return api.entity.get_all_authentites(serverParams).then((response)=>{

            tab_temp.push(response.data.data)
            commit('setEntity', tab_temp)
            tab_temp=[]
            return response.data.data
        })
    },
    get_all_typesentite({ commit }){
        return api.entity.get_all_typesentite().then((response)=>{          
            commit('settypesentity', response.data.data)
            return response.data.data
        })
    },
    post_logactivity({ commit }, serverParams){
        return api.mouchards.post_logactivity(serverParams).then((response)=>{
            //console.log(response.data.data)
            commit('logActivities', response.data.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    put_entity({commit},data){
        return api.entity.put_entites(data.id,data.entity).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_entites({commit},id){
        return api.entity.show_entites(id).then((response)=>{
            return response.data.data;
        })
    },
    delete_entites({commit},id){
        return api.entity.delete_entites(id).then((response)=>{
            console.log(response.data)
            return response.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
